import type { TCompany } from "@/types"
import { api } from "./api"

export async function updateAPICompany(data: Partial<TCompany>) {
  const { data: company } = data.id
    ? await api.put<TCompany>("/company", data)
    : await api.post<TCompany>("/company", data)
  return company
}
